"use client";
import { setRegisterComponent } from "@/store";
import { useTranslations } from "next-intl";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useDispatch } from "react-redux";

export const FormHelpText = ({ name, wrap }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const searchParams = useSearchParams()
  const template_id = searchParams.get('template_id')
  const t = useTranslations();
  const pathname = usePathname();
  const helpTexts = {
    reset_pass: {
      text: t("dontRememberPassword"),
      link_text: t("reset"),
      path: "forgot-password",
    },
    sign_up: {
      text: t("notMember"),
      link_text: t("sign-up"),
      path: "sign-up",
    },
    back_to_sign: {
      text: t("rememberPassword"),
      link_text: t("backSignIn"),
      path: "sign-in",
    },
    sign_in: {
      text: t("alreadyAccount"),
      link_text: t("sign-in"),
      path: "sign-in",
    },
  };
  const { text, link_text, path } = helpTexts[name];
  const wrapClass = wrap && "flex-col md:flex-row";
  const handlePathname = () => {
    if (pathname == "/website") {
      dispatch(setRegisterComponent(path))
      return router.push(`/website?step=2&template_id=${template_id}&path=${path}`);

    }
    else router.push(path);
  };
return (
  <div
    className={`${wrapClass} flex flex-col md:flex-row mx-auto items-center justify-center gap-[4px]`}
  >
    <span className="text-[#64748B] text-base">{text}</span>
    <span
      onClick={() => handlePathname()}
      className="cursor-pointer text-mainLightPurple text-base font-bold"
    >
      {link_text}
    </span>
  </div>
);
};
